// JsFromRoutes CacheKey 1ea2aa03530f37689cb2adc550394244
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  transcribe: /* #__PURE__ */ definePathHelper('post', '/:org_nano_id/voice_notes/transcribe'),
  create: /* #__PURE__ */ definePathHelper('post', '/:org_nano_id/voice_notes'),
}
